const downloadConfig = {
    BLOCK_SIZE: 512 * 1024, // 分块单位
    FIRST_INTERVAL_BLOCK_SIZE: 512 * 1024 * 4, // 第一次请求的时候请求的vdn长度
    INTERVAL_BLOCK_SIZE: 512 * 1024 * 4, // 每次vdn请求长度
    P2PBLOCK_SIZE: 1 * 1024, // p2p一次传送大小
    P2P_DOWNLOAD_COUNT: 1, // p2p下载个数
    mServerInfo:'http://111.202.92.78:80/inquiry_IP',//测试用trackserver服务器地址
    vStaUrl:'http://p2p.v.ifeng.com/log.js',//发送统计服务器地址
    receiveDataTimeOut:8000,//p2p接收数据定时
};

export default downloadConfig;


// WEBPACK FOOTER //
// ./components/f.component.mediasource/app/modules/downloadConfig.js